import React, { memo } from 'react';
import Switch from "react-switch";
import { FormGroup, Label } from 'reactstrap';

const CustomDropdown = memo(({
    id,
    name,
    label,
    value,
    onChange,
    options = [],
    placeholder = "Select...",
    className = '',
    dropdownDisabled = false,
    required = false,
    isLoading = false,
    isSearchable = false,
    error = null,
    handleSwitchToggle,
    isSwitchEnabled,
    hideSwitch = false,
    ...props
}) => {
    // Create a unique ID if none provided

    return (
        <FormGroup className={`mb-3 ${className}`}>
            {label && (
                <Label htmlFor={id} className="col-form-label-sm d-flex align-items-center">
                    {label} {required && <span className="text-danger ms-1">*</span>}
                </Label>
            )}
              <div className="input-group">
                <select
                    name={name}
                    id={id}
                    className={`form-select form-select-sm ${error ? 'is-invalid' : ''}`}
                    value={value || ""}
                    onChange={onChange}
                    disabled={dropdownDisabled || isLoading}
                    required={required}
                    {...props}

                >
                    {value == "" && <option value="">{isLoading ? "Loading..." : placeholder}</option>}
                    {options.map(option => (
                        <option
                            key={option.value}
                            value={option.value}
                        >
                            {option.label}
                        </option>
                    ))}
                </select>
                <div className="d-flex align-items-center ms-3">
                    {!hideSwitch ? <Switch
                        onChange={handleSwitchToggle}
                        checked={isSwitchEnabled}
                        height={20}
                        width={40}
                        handleDiameter={18}
                        offColor="#bbb"
                        onColor="#0d6efd"
                        uncheckedIcon={false}
                        checkedIcon={false}
                        id={`${id}-switch`}
                    /> : <div style={{ width: 40, height: 20 }}></div>}
                </div>
            </div>

        </FormGroup>
    );
});

CustomDropdown.displayName = 'CustomDropdown';

export default CustomDropdown;
